import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

function initSwiper(element) {
  if (!element) return;

  const swiper = new Swiper(element, {
    modules: [FreeMode],
    freeMode: {
      momentum: false,
    },
    direction: 'vertical',
    spaceBetween: 25,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
  });

  swiper.on('progress', (swiper, progress) => {
    if (progress <= 0) {
      element.classList.add('swiper--is-at-beginning');
    } else {
      element.classList.remove('swiper--is-at-beginning');
    }

    if (progress >= 1) {
      element.classList.add('swiper--is-at-end');
    } else {
      element.classList.remove('swiper--is-at-end');
    }
  });
}

function initTimeline(parent) {
  const swiper = parent.querySelector('.vertical-timeline__swiper');
  initSwiper(swiper);

  const months = parent.querySelectorAll('.vertical-timeline__month');

  const selectMonth = (newMonth) => {
    months.forEach((month) => {
      if (month === newMonth) {
        month.classList.add('is-active');
      } else {
        month.classList.remove('is-active');
      }
    });
  };

  months.forEach((month) => {
    month.addEventListener('click', () => selectMonth(month));
  });
}

export function verticalTimeline(selector = '.vertical-timeline') {
  document.querySelectorAll(selector).forEach((element) => initTimeline(element));
}
